import React from "react";
import "./logo.css";
import logoLight from "../../assets/imgs/logo-transparent-light.gif";

const Logo = ({ location = "yc", src, className, style }) => {
  return (
    <div className={`logo ${className || ""}`.trim()} style={style}>
      <img src={src || logoLight} 
      className="invert-[--inyc-invert-black]"
      alt="logo" />
    </div>
  );
};

export default Logo;
